'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _number_utility = require('../../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _formatted_number = require('../global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _reactIntl = require('react-intl');

var _string_utility = require('common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _collection_utility = require('../../../../packages/common-utilities/src/collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarYearPerformanceChart = function (_React$Component) {
  _inherits(CalendarYearPerformanceChart, _React$Component);

  function CalendarYearPerformanceChart() {
    _classCallCheck(this, CalendarYearPerformanceChart);

    return _possibleConstructorReturn(this, (CalendarYearPerformanceChart.__proto__ || Object.getPrototypeOf(CalendarYearPerformanceChart)).apply(this, arguments));
  }

  _createClass(CalendarYearPerformanceChart, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'FLAT_MODE') && ((0, _ramda.isNil)(nextProps) || !(0, _ramda.equals)(this.props, nextProps) || !(0, _ramda.equals)(this.state, nextState)) || !_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'FLAT_MODE');
    }

    /* eslint-disable*/

  }, {
    key: 'createCalendarYearPerformanceChart',
    value: function createCalendarYearPerformanceChart(printWidth) {
      var data = this.createCalendarYearPerformanceChartData(this.props.historicalCalendarYearPerformanceReturn);
      var isDesktop = this.props.breakpoint > 3;
      var xAxisTicks = this.props.historicalCalendarYearPerformanceReturn.labels;
      var marginRight = isDesktop ? 20 : 10;
      var yAxisTicks = this.getCalendarYearPerformanceTicks(data);
      var numberFormat = this.props.numberFormat;

      var spec = {
        "endLabel": {
          "text": function text(data) {
            if (data.return === 0) {
              return "";
            } else {
              return _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertDecimalToMultiply100WithFixedDecimals(data.return, 2), numberFormat);
            }
          },
          "position": "adjacent",
          "style": {
            "font-family": "NBInternational",
            "font-size": "14px",
            "font-weight": "400",
            "fill": "#2b2b2b"
          }
        },
        "label": {
          "show": false
        },
        "selector": "#RollingReturnsChart",
        "keys": ["date", "type"],
        "values": ["return"],
        "type": "grouped",
        "container": {
          "marginBottom": 70,
          "marginLeft": 50,
          "scaled": true,
          "marginRight": marginRight,
          "height": 550
        },
        "style": {
          "fill": ["#70C4FF", "#00A16D"]
        },
        "axis": {
          "x": {
            "show": true,
            "domain": [xAxisTicks[0], xAxisTicks[xAxisTicks.length - 1]],
            "tick": {
              "values": xAxisTicks
            },
            "label": {
              "show": true,
              "style": {
                "font-family": "NBInternational",
                "font-size": "12px"
              }
            }
          },
          "y": {
            "domain": [yAxisTicks[0], yAxisTicks[yAxisTicks.length - 1]],
            "show": true,
            "ticks": yAxisTicks.length,
            "tick": {
              "padding": 10,
              "values": yAxisTicks,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              }
            },
            "label": {
              "style": {
                "font-family": "NBInternational",
                "font-size": "12px"
              },
              "text": function text(d) {
                return d * 100 + "%";
              }
            }
          }
        }
      };

      if (printWidth && typeof printWidth === "number") {
        spec.width = (0, _chart_utility.getChartPrintWidth)();
        spec.height = (0, _chart_utility.getChartPrintHeight)();
      }

      return _chart_utility2.default.generateChart((0, _chart_utility.generateChartId)("CalYearPerfReturnsChart", printWidth && typeof printWidth === "number"), "bar", data, spec);
    }
  }, {
    key: 'getCalendarYearPerformanceTicks',
    value: function getCalendarYearPerformanceTicks(data) {
      var maxPositiveValue = Math.max.apply(Math, data.map(function (o) {
        return o.return;
      }));
      var maxNegativeValue = Math.min.apply(Math, data.map(function (o) {
        return o.return;
      }));

      var largestValue = maxPositiveValue > Math.abs(maxNegativeValue) ? maxPositiveValue : Math.abs(maxNegativeValue);
      largestValue *= 100;

      var smallestPermittedMaxValue = 20;
      var tickIncrement = 10;

      if (largestValue > 10) {
        largestValue = Math.ceil(largestValue / 10) * 10;
      } else if (largestValue < 5) {
        smallestPermittedMaxValue = 5;
        tickIncrement = 1;
      } else {
        smallestPermittedMaxValue = 10;
        tickIncrement = 2;
      }

      if (largestValue < smallestPermittedMaxValue) {
        largestValue = smallestPermittedMaxValue;
      }

      var currentTick = largestValue * -1;
      var ticks = [];
      while (currentTick <= largestValue) {
        ticks.push(currentTick / 100);
        currentTick += tickIncrement;
      }
      return ticks;
    }
  }, {
    key: 'createCalendarYearPerformanceChartData',
    value: function createCalendarYearPerformanceChartData(data) {
      var ObjMapping = ["oneYear", "twoYears", "threeYears", "fourYears", "fiveYears", "sixYears", "sevenYears", "eightYears", "nineYears", "tenYears"];
      var shareclassData = data.labels.map(function (item, index) {
        return {
          date: item,
          type: 'Shareclass',
          return: data.performanceData[0][ObjMapping[index]]
        };
      });

      var benchmarkData = data.labels.map(function (item, index) {
        return {
          date: item,
          type: 'Benchmark',
          return: data.performanceData[1][ObjMapping[index]]
        };
      });

      return shareclassData.concat(benchmarkData);
    }
  }, {
    key: 'renderLegend',
    value: function renderLegend() {
      var shareclassName = this.props.shareclassName;
      var intl = this.props.intl;

      var createLegendSquare = function createLegendSquare(backgroundColor) {
        return _react2.default.createElement('div', { 'data-testid': 'chart-legend-icon', className: 'display-inline-block', style: {
            width: "20px",
            height: "20px",
            backgroundColor: backgroundColor,
            marginRight: "15px",
            verticalAlign: "middle",
            borderRadius: "25px"
          } });
      };

      return _react2.default.createElement(
        'div',
        { className: 'margin-bottom-40', 'data-testid': 'chart-legend' },
        _react2.default.createElement(
          'div',
          { className: 'tag chart-legend' },
          createLegendSquare('#70C4FF'),
          _react2.default.createElement(
            'span',
            { className: 'font-regular', 'data-testid': 'chart-legend-cal-year-shareclass-name' },
            _string_utility2.default.getLocalizedString(intl, "Shareclass", "pdp-shareclass-lowercase"),
            ': ',
            shareclassName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tag chart-legend' },
          createLegendSquare("#00A16D"),
          _react2.default.createElement(
            'span',
            { className: 'font-regular', 'data-testid': 'chart-legend-cal-year-benchmark' },
            _string_utility2.default.getLocalizedString(intl, "Benchmark", "Benchmark")
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.historicalCalendarYearPerformanceReturn.length === 0) {
        return null;
      }
      var chart = this.createCalendarYearPerformanceChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(chart),
          this.renderLegend()
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createCalendarYearPerformanceChart(800)),
          this.renderLegend()
        )
      );
    }
  }]);

  return CalendarYearPerformanceChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = (0, _reactIntl.injectIntl)(CalendarYearPerformanceChart, { withRef: true });